import React, { useEffect, useState } from "react";
import "./userviewmodal.css";
import { Modal, Button } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { PhoneInput } from "react-international-phone";

const UserViewModal = ({ show, handleClose, user }) => {
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});
  const [name,setName]=useState("");
  const [email,setEmail]=useState("");
  const [phoneNumber,setPhoneNumber]=useState("");
  const [role,setRole]=useState("");

  const handleUserViewBackButton = () => {
    navigate("/usertable-page");
  };

  useEffect(()=>{
    if(user)
    {
       setName(user?.userName || "");
       setEmail(user?.userEmail || "");
       setPhoneNumber(user?.userPhoneNumber || "");
       setRole(user?.role || "")
    }
  },[user])

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>View User</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form>
            <div className="container-fluid">
              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label">Agent Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={name}
                    readOnly
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    value={email}
                    readOnly
                  />
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-md-6">
                  <label className="form-label">Phone Number</label>
                  <PhoneInput
                    defaultCountry="in"
                    value={phoneNumber}
                    onChange={() => {}}
                    readOnly
                  />
                  {errors.userPhoneNumber && (
                    <small className="text-danger">
                      {errors.userPhoneNumber}
                    </small>
                  )}
                </div>

                <div className="col-md-6">
                  <label className="form-label">Role</label>
                  <input
                    type="text"
                    className="form-control"
                    value={role ? role.toUpperCase() : ""}
                    readOnly
                  />
                </div>
              </div>

               
              <div className="d-flex justify-content-end gap-2">
                <button
                  className="users-back-button"
                  onClick={handleUserViewBackButton}
                >
                  <IoIosArrowBack /> Back
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default UserViewModal;
